import { render, staticRenderFns } from "./MenuBarUserHelp.vue?vue&type=template&id=5468a306&"
import script from "./MenuBarUserHelp.vue?vue&type=script&lang=js&"
export * from "./MenuBarUserHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports